import styled from "styled-components";

export const ClientWrapper = styled.div`
    margin-left: 18%;
    margin-top: -42%;

    h2 {
        color: #666666;
    }
    select{
        border: 1px solid #CCD7DD;
        height: 42px;
        color: #666666;
    }
    input {
        border: 1px solid #CCD7DD;
        height: 36px;
        padding-left: 5px;
        outline:none;
    }

    button {
        height: 42px;
        width: 100px;
        margin-left: 1%;
        border: 1px solid #57C4F5;
        outline: none;
        cursor : pointer;
        background: #57C4F5;
        color: white;
    }
`